import polylabel from 'polylabel';

const PRECISION = 0.0001;

// returns the bbox around the incircle of the current geometry (only Polygons and MultiPolygons)
// holes in geometry are ignored
export default function geojsonInnerBbox(geoJson) {
  let circle;
  if (geoJson.type === 'Polygon') {
    circle = polylabel(geoJson.coordinates.slice(0, 1), PRECISION);
  } else if (geoJson.type === 'MultiPolygon') {
    circle = geoJson.coordinates.reduce((res, component) => {
      const componentCircle = polylabel(component.slice(0, 1), PRECISION);
      return !res || res.distance < componentCircle.distance
        ? componentCircle
        : res;
    }, null);
  } else {
    return null;
  }
  return [
    [circle[1] - circle.distance, circle[0] - circle.distance],
    [circle[1] + circle.distance, circle[0] + circle.distance],
  ];
}
